export const youtubeKeys = {
  youtube_analytics: (videoId: number) => ['YOUTUBE_ANALYTICS', videoId], // get youtube video analytics,
  youtube_integration_status: () => ['YOUTUBE_INTEGRATION_STATUS'],
};
